import { Link } from 'gatsby';
import styled from 'styled-components';
import { blackGray, darkGray, gray, media } from '../../utils/styles';
import { rhythm } from '../../utils/typography';
import { Image } from '../Image';

export const CardsGridWrap = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  margin: ${rhythm(1)} -${rhythm(1 / 2)};
  width: 100%;
`;

export const CardImg = styled(Image)`
  width: 100%;
  height: 140px;
  ${media.mobileS` height: 180px; `}
`;

export const Title = styled.h3`
  margin: 18px 0 4px 0;
`;

export const Card = styled(Link)`
  flex-basis: 25%;
  ${media.tablet` flex-basis: 33%; `}
  ${media.mobileL` flex-basis: 50%; `}
  ${media.mobileS` flex-basis: 100%; `}

  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  padding: ${rhythm(1)} ${rhythm(1 / 2)};

  &:hover {
    cursor: pointer;
  }
  
  &:hover ${CardImg} {
    transform: translateY(-2px);
    box-shadow: 0 4px 4px -2px ${gray};
  }
  
  &:hover ${Title} {
    color: ${blackGray};
  }
`;

export const SubTitle = styled.span`
  color: ${darkGray};
`;

export const Count = styled.span`
  margin-top: ${rhythm(1 / 3)};
  font-size: ${rhythm(1 / 2)};
  font-style: italic;
  color: ${gray};
`;
